import 'angular:locale/data:es-es';
import 'angular:locale/data:pl-pl';
import 'angular:locale/data:pt-br';
import 'angular:locale/data:en-us';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
